import matchEntities from './entityHelpers';

export default function getOurProductScrollerItemsByEntity(entity, i18n) {
  const scrollerItems = [
    {
      active: true,
      header: 'our_product.card1.header',
      text: 'our_product.card1.content',
      png: `assets/homePage/iphone-map-${entity}-${i18n.locale}.png`,
      webP: `assets/homePage/iphone-map-${entity}-${i18n.locale}.webp`,
    },
    {
      active: false,
      header: 'our_product.card3.header',
      text: 'our_product.card3.content',
      png: `assets/homePage/iphone-charging-${entity}-${i18n.locale}.png`,
      webP: `assets/homePage/iphone-charging-${entity}-${i18n.locale}.webp`,
    },
  ];
  if (matchEntities(['POLAND'])) {
    scrollerItems.push({
      active: false,
      header: 'our_product.card2.header',
      text: 'our_product.card2.content',
      png: `assets/homePage/iphone-rfidcard-${entity}-${i18n.locale}.png`,
      webP: `assets/homePage/iphone-rfidcard-${entity}-${i18n.locale}.webp`,
    });
  }
  return scrollerItems;
}

const reservationIcon = require('@/assets/reservation-ic.svg');
const paymentIcon = require('@/assets/payment-ic.svg');
const cableIcon = require('@/assets/cable-ic.svg');
const greenCableIcon = require('@/assets/cable-ic-green.svg');
const customerHappinesIcon = require('@/assets/ch-hotline-ic.svg');
const greenEnergyIcon = require('@/assets/green-energy-ic.svg');

export function cardScreenCards() {
  const cards = [
    {
      header: 'our_solution.card1.header',
      text: 'our_solution.card1.content',
      icon: matchEntities(['POLAND', 'NETHERLANDS'])
        ? greenEnergyIcon
        : reservationIcon,
    },
    {
      header: 'our_solution.card2.header',
      text: 'our_solution.card2.content',
      icon: paymentIcon,
    },
    {
      header: 'our_solution.card3.header',
      text: 'our_solution.card3.content',
      icon: matchEntities(['POLAND', 'NETHERLANDS'])
        ? customerHappinesIcon
        : cableIcon,
    },
  ];

  if (matchEntities(['SWEDEN'])) {
    cards.push({
      header: 'our_solution.card4.header',
      text: 'our_solution.card4.content',
      icon: greenCableIcon,
    });
  }
  return cards;
}
export function getBulletsByEntity() {
  if (matchEntities(['POLAND', 'NETHERLANDS'])) {
    return [
      'faq_screen.qwello',
      'faq_screen.app',
      'faq_screen.pricing',
      // 'faq_screen.reserve',
      'faq_screen.stations',
      'faq_screen.charging',
    ];
  }
  return [
    'faq_screen.qwello',
    'faq_screen.app',
    'faq_screen.pricing',
    'faq_screen.reserve',
    'faq_screen.stations',
    'faq_screen.charging',
  ];
}
